import { createContext } from "react";
import { StatusReport } from "@/Pages/StatusReport";

interface StatusReportContextProps {
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    demoStatusReport: StatusReport | undefined;
    setDemoStatusReport: (report: StatusReport | undefined) => void;
}

export const StatusReportContext = createContext<StatusReportContextProps>({
    demoMode: false,
    setDemoMode: () => {},
    demoStatusReport: undefined,
    setDemoStatusReport: () => {},
});
